<template>
  <ListingsFilterControl :label="label">
    <VBetween
      :value="convertedValue"
      :options="options"
      arrow-icon-class-name="fr fr-chevron-down"
      @on-change="emitUpdateModelValue"
    />
  </ListingsFilterControl>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  // Types
  import type { PropType, ComputedRef } from 'vue';
  import type { TVBetweenValue, TVBetweenOption } from '~/misc/v-between/types';
  import type { TQueryRange } from '~/misc/listings/types';

  // Services
  import { RangeConverter } from '~/misc/services/range-converter';

  // Components
  import ListingsFilterControl from '~/misc/listings/filters/control/ListingsFilterControl.vue';
  import VBetween from '~/misc/v-between';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: TQueryRange): void;
  }>();

  const props = defineProps({
    modelValue: {
      type: Object as PropType<TQueryRange>,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Object as PropType<TVBetweenOption<string, number>[]>,
      required: true,
    },
    defaultRange: {
      type: Object as PropType<TQueryRange>,
      required: true,
    },
  });

  const convertedValue: ComputedRef<TVBetweenValue> = computed<TVBetweenValue>(() =>
    RangeConverter.convertRangeToArray(props.modelValue)
  );

  const emitUpdateModelValue = (value: TVBetweenValue) =>
    emit('update:modelValue', RangeConverter.convertRangeToObject(value, props.defaultRange));
</script>
